import React from 'react';

export default function DropdownIcon() {
  return (
    <svg width="256px" height="256px" viewBox="0 0 256 256" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <title>v2-single-option</title>
      <desc>Created with Sketch.</desc>
      <g id="v2-single-option" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Group-Copy-4" transform="translate(0.000000, 73.000000)" fill="#000000" fillRule="nonzero">
          <g id="Group-Copy-2">
            <path
              d="M16,16.5981308 L16,94.4018692 L240,94.4018692 L240,16.5981308 L16,16.5981308 Z M9,0 L247,0 C251.970563,0 256,4.18007042 256,9.3364486 L256,101.663551 C256,106.81993 251.970563,111 247,111 L9,111 C4.02943725,111 0,106.81993 0,101.663551 L0,9.3364486 C0,4.18007042 4.02943725,0 9,0 Z"
              id="Rectangle"
              fill="currentColor"
            ></path>
            <path
              d="M196.255429,43.650483 C198.968261,40.9593468 203.349042,40.9769348 206.040179,43.6897669 C208.731315,46.402599 208.713727,50.7833809 206.000895,53.474517 L192.014034,67.349517 C189.316592,70.0253862 184.96601,70.0253862 182.268568,67.349517 L168.281708,53.474517 C165.568876,50.7833809 165.551288,46.402599 168.242424,43.6897669 C170.93356,40.9769348 175.314342,40.9593468 178.027174,43.650483 L187.141301,52.6917197 L196.255429,43.650483 Z"
              id="Path-2"
              fill="currentColor"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
}
